
export default {
  method: 'post',
  // 基础url前缀
  baseURL: process.env.VUE_APP_SERVER_HOST,
  // 请求头信息
  headers: {},
  // 参数
  data: {},
  // 设置超时时间
  timeout: 50000,
  // 携带凭证
  withCredentials: false,
  // 返回数据类型
  responseType: 'json'
}
